import styled                 from 'styled-components';
import Box                    from '@mui/material/Box';
import { Grid, ListItem } from '@mui/material';
import { colorTheme }         from '@styles/muiTheme';
import { NumberInput }        from '@shared/inputs/NumberInput';
import { PhoneInput }         from '@shared/inputs/PhoneInput/PhoneInput';
import { TextInput }          from '@shared/inputs/TextInput';
import { ZipCodeInput }       from '@shared/inputs/ZipCodeInput/ZipCodeInput';
import { ILinearLoaderProps } from '@shared/components/grid/overlays/components/LinearLoader';

export const GridNumberInput = styled(NumberInput)`
  && {
    height: 35px;
    border-radius: 8px;

    .MuiInputBase-root {
      border-radius: 8px;

      .MuiInputBase-input {
        border: none;
      }
      
      input {
        padding: 16.5px 2px;
      }
    }
  }
`;

export const GridPhoneInput = styled(PhoneInput)`
  && {
    height: 35px;
    background: ${colorTheme.palette.common.white};
    border-radius: 8px;

    .MuiInputBase-root {
      border-radius: 8px;

      .MuiInputBase-input {
        border: none;
      }
    }
  }
`;

export const GridAutocompleteWrapper = styled.div<{ error?: boolean }>`
  fieldset {
    border: none;
  }

  .MuiAutocomplete-inputRoot .MuiAutocomplete-input {
    width: 100%;
    transform: translate(0, -5px);
    border-bottom: ${({ error }) => error && `1px solid ${colorTheme.palette.error.main}`} !important;
  }

  .MuiOutlinedInput-root {
    padding: 5px 9px 9px 9px;
  }
`;

export const GridAutocompleteFieldWrapper = styled.div`
  width: 100%;

  .MuiOutlinedInput-root,
  .MuiAutocomplete-input {
    padding-top: 7px !important;
  }
  
  .MuiAutocomplete-tag {
    margin-top: -1px !important;
  }
`;

export const GridTextInput = styled(TextInput)`
  && {
    height: 35px;
    border-radius: 8px;
    
    .MuiInputBase-input {
      border: none;
    }
  }
`;

export const GridZipCodeInput = styled(ZipCodeInput)`
  && {
    height: 35px;
    border-radius: 8px;

    .MuiInputBase-root {
      border-radius: 8px;

      .MuiInputBase-input {
        border: none;
      }
    }
  }
`;

export const LinearLoaderWrapper = styled(Box).withConfig<ILinearLoaderProps>({ shouldForwardProp: (prop) => prop !== 'fullWidth' })(
  ({ fullWidth }) => `
  position: absolute;
  width: ${fullWidth ? 'calc(100% + 40px)' : '100%'};
  margin: ${fullWidth ? '0 -20px' : '0'};
  z-index: 1;
`,
);

export const GridWrapper = styled.div`
  .MuiDataGrid-detailPanels {
    .MuiDataGrid-columnHeaders {
      display: none;
    }
    .MuiDataGrid-virtualScroller {
      margin-top: 0 !important;
      border-top: 1px solid ${colorTheme.palette.secondary.light};
      overflow: auto !important;
    }
  }
`;

export const GridContentWrapper = styled(Grid)`
  border: 1px solid ${colorTheme.palette.secondary.main};
  border-radius: 5px;
`;

export const CalculatorListItem = styled(ListItem)`
  font-weight: bold;
  padding: 2px 0;
  width: 75%;
`;